export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  contentHtml: string;
  categoryId: string;
  categoryName: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  image: string;
  views: number;
  likes: number;
  comments: number;
  tags: string[];
  isHot: boolean;
  isRecommended: boolean;
}

export const articles: Article[] = [
  {
    id: "art-1",
    title: "2026年最值得入手的旗舰手机横评：谁才是真正的机皇？",
    slug: "2026-flagship-phone-comparison",
    excerpt: "随着2026年各大品牌旗舰机型陆续发布，我们针对市面上最热门的五款旗舰手机进行了全面对比评测，从性能、影像、续航到系统体验，帮你找到最适合的那一款。",
    contentHtml: `<p>2026年已经过半，主流手机厂商的旗舰产品线已经全部更新完毕。面对琳琅满目的选择，消费者往往会陷入"选择困难症"。今天我们就来做一个全面的横向对比，帮你理清思路。</p>

<h2>一、性能表现：骁龙8 Gen 4 vs 天玑9400</h2>
<p>今年的旗舰芯片之争可以说是近年来最激烈的一次。高通骁龙8 Gen 4采用了全新的3nm+工艺，CPU性能相比上代提升了约25%，能效比更是大幅优化。而联发科天玑9400也不甘示弱，在AI算力和图形处理方面表现亮眼。</p>
<p>在实测中，两者的综合跑分差距不到5%，日常使用几乎感受不到差异。但在高负载游戏场景下，骁龙8 Gen 4的持续性能释放更加稳定，这得益于其更优秀的散热设计。</p>

<h2>二、影像系统：计算摄影的新高度</h2>
<p>2026年的手机影像已经全面进入AI深度参与的时代。各家厂商不再单纯比拼硬件参数，而是在算法和用户体验上下功夫。</p>
<p>从实拍样张来看，夜景表现依然是拉开差距的关键。搭载1英寸大底传感器的机型在极限暗光环境下优势明显，而AI多帧合成技术让中小底机型也能够在大多数日常场景中拍出令人满意的照片。</p>

<h2>三、续航与充电</h2>
<p>得益于硅碳负极电池技术的普及，今年的旗舰机型普遍配备了5500mAh以上的大容量电池。实测续航表现中，表现最好的机型能够实现近两天的轻度使用续航。</p>
<p>充电方面，百瓦快充已经成为标配，最快的机型从0充到100%仅需18分钟。无线充电功率也普遍来到了80W，实用性大大提升。</p>

<h2>四、系统与生态体验</h2>
<p>AI大模型已经成为手机系统的标配功能。从智能助手到实时翻译，从图片编辑到会议记录，AI正在改变我们与手机交互的方式。各家厂商的AI功能侧重点不同，但整体方向都是在提升效率和创造力。</p>

<h2>总结推荐</h2>
<p>综合来看，如果你追求全面均衡的体验，三星Galaxy S26 Ultra依然是稳妥之选；如果你对影像有极致追求，搭载一英寸大底传感器的国产旗舰值得考虑；如果你预算有限但又想要旗舰体验，那么次旗舰机型可能是性价比最高的选择。</p>
<p>无论选择哪一款，2026年的旗舰手机都能提供远超日常需求的使用体验。根据自己的预算和偏好做出选择，都不会错。</p>`,
    categoryId: "cat-1",
    categoryName: "科技数码",
    categorySlug: "tech",
    author: "数码达人小王",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20tech%20blogger%20avatar%20portrait%20clean%20minimal%20style&width=100&height=100&seq=author-avatar-1&orientation=squarish",
    publishDate: "2026-08-03",
    image: "https://readdy.ai/api/search-image?query=Modern%20smartphone%20flat%20lay%20on%20warm%20minimal%20desk%20with%20soft%20natural%20lighting%2C%20clean%20aesthetic%20product%20photography%2C%20warm%20cream%20background%2C%20editorial%20style%20with%20gentle%20shadows&width=800&height=450&seq=art-tech-1&orientation=landscape",
    views: 18520,
    likes: 2341,
    comments: 456,
    tags: ["手机评测", "旗舰手机", "数码产品", "2026推荐"],
    isHot: true,
    isRecommended: true,
  },
  {
    id: "art-2",
    title: "家常红烧肉的终极秘诀：软糯不腻，入口即化",
    slug: "braised-pork-belly-secrets",
    excerpt: "红烧肉是中华美食的经典代表。本文将分享一道传承三代的家庭秘方，教你如何做出色泽红亮、肥而不腻、入口即化的完美红烧肉。",
    contentHtml: `<p>红烧肉，这道看似简单的家常菜，其实藏着无数烹饪智慧和技巧。今天就来分享我家传了三代的红烧肉秘方，保证让你一次成功。</p>

<h2>选材是关键第一步</h2>
<p>做红烧肉首选五花三层分明的精品五花肉。肥瘦相间的层次越多，口感越丰富。建议选择靠近猪肋骨部位的肉，这个部位的五花纹路最漂亮，肉质也最嫩。</p>
<p>买回来的肉不要急着切，先放入冷水中浸泡30分钟，中间换一次水，可以有效去除血水和腥味。</p>

<h2>焯水有讲究</h2>
<p>很多人做红烧肉会忽略焯水这一步，或者焯水方式不对。正确的做法是：冷水下锅，加入几片姜和一小段葱，大火烧开后继续煮3-5分钟，撇去浮沫，捞出用温水冲洗干净。</p>
<p><strong>注意：一定要用温水冲洗，用冷水会让肉质瞬间收缩变柴。</strong></p>

<h2>炒糖色是灵魂</h2>
<p>红烧肉的"红"来自于糖色。锅烧热后转小火，放入冰糖慢慢翻炒。冰糖开始融化时不要着急，继续小火慢炒，直到糖浆变成深琥珀色，冒出细密的小泡，这时候迅速放入焯好水的五花肉翻炒上色。</p>
<p>新手最容易犯的错误是火太大把糖炒糊了。一旦糖炒糊，整道菜就会有苦味。宁愿颜色浅一点，也不要冒这个风险。</p>

<h2>慢火炖煮出真味</h2>
<p>加入生抽、老抽、料酒和足量的开水（水量要没过肉），放入八角、桂皮、香叶。大火烧开后转最小火，盖上锅盖慢炖至少90分钟。</p>
<p>期间不要频繁开盖，保持锅内的温度和湿度稳定。最后一刻钟开盖转大火收汁，看到汤汁变得浓稠油亮即可出锅。</p>

<h2>点睛之笔</h2>
<p>出锅前撒上一小把葱花，不仅增添色彩，葱的清香还能中和肉的油腻感。如果能配上一碗热腾腾的白米饭，那简直是人间至味。</p>`,
    categoryId: "cat-2",
    categoryName: "生活娱乐",
    categorySlug: "lifestyle",
    author: "美食家老李",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20food%20blogger%20avatar%20portrait%20warm%20style&width=100&height=100&seq=author-avatar-2&orientation=squarish",
    publishDate: "2026-08-02",
    image: "https://readdy.ai/api/search-image?query=Delicious%20Chinese%20braised%20pork%20belly%20in%20clay%20pot%2C%20glossy%20red%20sauce%2C%20garnished%20with%20green%20onions%2C%20warm%20wooden%20table%20setting%2C%20soft%20natural%20light%2C%20food%20photography%20style%20with%20shallow%20depth&width=800&height=450&seq=art-life-1&orientation=landscape",
    views: 32450,
    likes: 4521,
    comments: 823,
    tags: ["美食", "家常菜", "红烧肉", "烹饪教程"],
    isHot: true,
    isRecommended: true,
  },
  {
    id: "art-3",
    title: "Python编程入门：从零基础到写出第一个爬虫程序",
    slug: "python-crawler-beginner-guide",
    excerpt: "Python作为最受欢迎的编程语言之一，是很多编程新手的首选。本文将从环境搭建开始，一步步带你学习Python基础，最终实现一个简单的网页爬虫。",
    contentHtml: `<p>Python是当今最热门的编程语言之一，以其简洁优雅的语法和强大的生态而闻名。对于编程零基础的你来说，Python是开启编程之旅的理想选择。</p>

<h2>为什么要学Python？</h2>
<p>Python的应用领域极其广泛：Web开发、数据分析、人工智能、自动化运维、网络爬虫……几乎每个技术方向都能看到Python的身影。更重要的是，Python的语法接近自然语言，学习曲线平滑，非常适合零基础入门。</p>

<h2>环境搭建：三步搞定</h2>
<p>第一步：访问Python官网下载最新版Python 3.13并安装，安装时务必勾选"Add Python to PATH"。</p>
<p>第二步：打开终端或命令提示符，输入 <code>python --version</code>，确认安装成功。</p>
<p>第三步：安装一个顺手的代码编辑器。推荐VS Code，免费且功能强大。</p>

<h2>基础语法速览</h2>
<p>变量和数据类型是编程的基础。Python中你不需要声明变量类型，直接赋值即可。常用的数据类型包括整数、浮点数、字符串、列表和字典。</p>
<p>条件判断使用 if-elif-else 结构，循环使用 for 和 while。Python的缩进非常重要，同一个代码块的缩进必须保持一致。</p>

<h2>实战：编写第一个爬虫</h2>
<p>我们将使用 requests 和 BeautifulSoup 库来抓取网页内容。首先安装这两个库：<code>pip install requests beautifulsoup4</code></p>
<p>爬虫的核心逻辑其实很简单：发送HTTP请求获取网页内容，然后用BeautifulSoup解析HTML，提取你需要的信息。下面是一个简单的示例：</p>

<blockquote>
<p>爬虫学习建议：先从静态网页开始，熟练掌握后再挑战需要登录或JavaScript渲染的动态页面。遵守网站的robots.txt规则，做一个负责任的爬虫开发者。</p>
</blockquote>

<h2>持续学习的路径</h2>
<p>掌握基础爬虫之后，你可以往这些方向深入：Scrapy框架、反爬虫应对策略、分布式爬虫、数据清洗和存储。每一步都有丰富的知识等待你去探索。</p>`,
    categoryId: "cat-3",
    categoryName: "学习教育",
    categorySlug: "education",
    author: "编程导师阿杰",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20tech%20educator%20avatar%20portrait%20modern%20style&width=100&height=100&seq=author-avatar-3&orientation=squarish",
    publishDate: "2026-08-01",
    image: "https://readdy.ai/api/search-image?query=Clean%20modern%20coding%20workspace%20with%20laptop%20showing%20Python%20code%20on%20screen%2C%20warm%20desk%20setup%20with%20coffee%20and%20notebook%2C%20minimalist%20aesthetic%2C%20soft%20natural%20lighting&width=800&height=450&seq=art-edu-1&orientation=landscape",
    views: 28560,
    likes: 3876,
    comments: 912,
    tags: ["Python", "编程入门", "爬虫", "技术教程"],
    isHot: true,
    isRecommended: false,
  },
  {
    id: "art-4",
    title: "《黑神话：悟空2》深度评测：国产3A的又一次飞跃",
    slug: "black-myth-wukong-2-review",
    excerpt: "作为《黑神话：悟空》的续作，这款备受期待的国产3A大作是否延续了前作的辉煌？经过60小时的深度体验，我们将从画面、战斗、剧情等维度为你带来全面解读。",
    contentHtml: `<p>距离《黑神话：悟空》震撼游戏界已经过去了两年，如今它的续作《黑神话：悟空2》终于与我们见面了。游戏科学团队这次交出的答卷是否令人满意？让我们一探究竟。</p>

<h2>画面表现：真正的次世代</h2>
<p>如果说前作的画面已经足够惊艳，那么续作在视觉呈现上又上了一个台阶。基于虚幻引擎5.4的全新技术栈，实时光线追踪、Nanite虚拟几何体等技术的全面应用，让游戏世界呈现出前所未有的细腻质感。</p>
<p>从花果山的云雾缭绕到天宫的庄严宏伟，每一个场景都像是一幅精美的国风画卷。人物面部表情的捕捉也更加细腻，角色的情感表达更加真实动人。</p>

<h2>战斗系统：深度与爽感的平衡</h2>
<p>续作的战斗系统在保留前作精髓的基础上，增加了更多的变化和深度。全新的"元神觉醒"系统让玩家可以在战斗中切换不同的战斗姿态，每种姿态都有独特的技能树和连招体系。</p>
<p>Boss战依然是游戏的最大亮点。本次登场的数十个Boss各具特色，从体型庞大的上古妖兽到灵活敏捷的妖王，每一场战斗都充满了挑战和惊喜。</p>

<h2>剧情叙事：更加宏大的神话篇章</h2>
<p>故事紧接着前作结局展开，悟空踏上了前往天宫的旅途。相比前作相对克制的叙事，续作的剧情格局更加宏大，涉及更多中国神话传说中的经典人物和故事。</p>
<p>支线任务的叙事质量也有了显著提升，不再是简单的跑腿打怪，而是融入了更多有深度的故事和情感表达。</p>

<h2>总结</h2>
<p>《黑神话：悟空2》不仅是一款优秀的续作，更是一次对中国游戏产业实力的再次证明。它在技术、艺术和玩法三个维度上都达到了世界一流水平，是2026年最值得游玩的游戏之一。</p>`,
    categoryId: "cat-4",
    categoryName: "游戏动漫",
    categorySlug: "gaming",
    author: "游戏观察员",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20game%20reviewer%20avatar%20portrait%20casual%20style&width=100&height=100&seq=author-avatar-4&orientation=squarish",
    publishDate: "2026-07-30",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20game%20scene%20with%20ancient%20temple%20and%20warrior%20monkey%20character%2C%20dramatic%20lighting%2C%20atmospheric%20landscape%2C%20artistic%20rendering%20style&width=800&height=450&seq=art-game-1&orientation=landscape",
    views: 56780,
    likes: 8921,
    comments: 2103,
    tags: ["黑神话悟空", "游戏评测", "国产3A", "单机游戏"],
    isHot: true,
    isRecommended: true,
  },
  {
    id: "art-5",
    title: "2026年暑期档电影推荐：这五部不容错过",
    slug: "2026-summer-movie-recommendations",
    excerpt: "暑期档是电影市场的黄金时期，今年暑期档强片云集。我们为你精选了五部不同类型的优秀电影，既有国产大片也有进口佳片。",
    contentHtml: `<p>暑期档向来是电影市场的兵家必争之地。2026年的暑期档可以说是近年来最强的一届，无论是数量还是质量都达到了新高度。</p>

<h2>《星际迷航：新纪元》</h2>
<p>经典科幻IP的全新重启之作，由《沙丘》导演丹尼斯·维伦纽瓦执导。影片以宏大的宇宙视角重新诠释了探索与未知的主题，视觉效果震撼，IMAX版本更是不可错过的观影体验。</p>

<h2>《封神第三部：武王伐纣》</h2>
<p>国产神话史诗系列的终章，延续了前两部的高水准制作。这一部聚焦于武王伐纣的宏大战争场面，特效场面的规模和精细度都达到了国产电影的新高度。</p>

<h2>《她来自未来》</h2>
<p>一部令人惊喜的国产科幻爱情片。故事讲述了一个来自2080年的女孩穿越到2026年，与当代青年之间发生的浪漫与冒险。影片在温情和笑点中探讨了科技与人性的关系。</p>

<h2>《深海迷城》</h2>
<p>国产悬疑惊悚片的新尝试。深海科考队在一次任务中遭遇未知事件，紧张的氛围营造和出人意料的剧情反转让这部影片成为暑期档的黑马。</p>

<h2>《猫狗大作战》</h2>
<p>适合全家观看的合家欢动画电影。精美的画面和温情的故事，让这部影片成为暑期亲子观影的首选。</p>`,
    categoryId: "cat-5",
    categoryName: "影视音乐",
    categorySlug: "entertainment",
    author: "影评人小林",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20movie%20critic%20avatar%20portrait%20artistic%20style&width=100&height=100&seq=author-avatar-5&orientation=squarish",
    publishDate: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=Cinema%20theater%20interior%20with%20warm%20ambient%20lighting%2C%20red%20velvet%20seats%2C%20film%20projector%20beam%2C%20atmospheric%20and%20elegant%20movie%20experience%2C%20soft%20focus&width=800&height=450&seq=art-movie-1&orientation=landscape",
    views: 21340,
    likes: 2987,
    comments: 634,
    tags: ["电影推荐", "暑期档", "影评", "观影指南"],
    isHot: false,
    isRecommended: true,
  },
  {
    id: "art-6",
    title: "科学减脂指南：告别节食，健康瘦下来",
    slug: "scientific-fat-loss-guide",
    excerpt: "减肥不等于挨饿。本文基于最新的运动科学和营养学研究，为你制定一份科学、可持续的减脂计划，让你在健康的基础上达到理想体重。",
    contentHtml: `<p>"管住嘴，迈开腿"是减脂的金科玉律，但具体怎么"管"怎么"迈"，里面大有学问。今天我们就从科学角度，聊聊减脂的正确打开方式。</p>

<h2>理解能量平衡：减脂的基本原理</h2>
<p>减脂的核心是创造能量缺口——让每天消耗的热量大于摄入的热量。但这个缺口不能太大，建议每天控制在300-500千卡之间。过大的缺口会导致身体启动"节能模式"，反而不利于减脂。</p>

<h2>饮食策略：吃对比吃少更重要</h2>
<p>很多人减肥第一反应就是少吃甚至不吃，这是最大的误区。正确的做法是调整饮食结构和质量：</p>
<ul>
<li>增加优质蛋白质摄入：鸡胸肉、鱼虾、豆制品等，每餐保证有一个巴掌大的蛋白质来源</li>
<li>选择复合碳水：糙米、燕麦、红薯代替精米白面</li>
<li>大量摄入蔬菜：每餐至少占盘子的一半</li>
<li>健康脂肪不可缺：坚果、牛油果、橄榄油适量摄入</li>
</ul>

<h2>运动规划：力量+有氧是最佳组合</h2>
<p>单纯的有氧运动虽然能消耗热量，但如果不配合力量训练，减重过程中肌肉流失会比较严重，导致基础代谢下降。建议每周进行3-4次力量训练加2-3次中等强度有氧。</p>

<h2>睡眠与压力管理</h2>
<p>这一点经常被忽略，但其实非常关键。睡眠不足会导致饥饿激素水平升高，让你更容易暴饮暴食。长期压力也会促进皮质醇分泌，导致腹部脂肪堆积。</p>

<h2>结语</h2>
<p>减脂是一场持久战，不是百米冲刺。保持耐心，享受过程，健康才是最终目标。</p>`,
    categoryId: "cat-6",
    categoryName: "健康养生",
    categorySlug: "health",
    author: "健身教练大刘",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20fitness%20coach%20avatar%20portrait%20athletic%20style&width=100&height=100&seq=author-avatar-6&orientation=squarish",
    publishDate: "2026-07-26",
    image: "https://readdy.ai/api/search-image?query=Healthy%20meal%20prep%20on%20wooden%20table%20with%20fresh%20vegetables%20and%20fruits%2C%20fitness%20equipment%20in%20background%2C%20bright%20natural%20light%2C%20clean%20aesthetic%20food%20photography&width=800&height=450&seq=art-health-1&orientation=landscape",
    views: 41230,
    likes: 5678,
    comments: 1345,
    tags: ["减脂", "健康", "运动", "饮食", "科学养生"],
    isHot: false,
    isRecommended: false,
  },
  {
    id: "art-7",
    title: "AI绘画工具横向评测：Midjourney V7 vs Stable Diffusion 4.0",
    slug: "ai-art-tools-comparison-2026",
    excerpt: "2026年AI绘画工具已经进入了全新阶段。我们对目前最主流的两款AI绘画工具进行了详细对比，从图像质量、可控性、效率等多个维度为你分析。",
    contentHtml: `<p>AI绘画技术在2026年迎来了质的飞跃。主流工具纷纷推出重大更新，生成质量已经达到了令人难以置信的高度。本文将对两款最主流的AI绘画工具进行深度对比。</p>

<h2>Midjourney V7：美学至上的艺术家</h2>
<p>Midjourney V7在图像美学方面依然保持着领先地位。新一代模型在光影处理和色彩搭配上更加出色，生成的图片往往具有极强的艺术感染力，可以直接用于商业设计。</p>
<p>新增的"风格迁移"功能允许用户上传参考图，AI会分析其风格特征并应用到生成结果中，这大大提高了创作的灵活性和可控性。</p>

<h2>Stable Diffusion 4.0：开源的力量</h2>
<p>SD 4.0最大的优势依然是开源和可控性。新版本在基础模型质量上大幅提升，已经非常接近Midjourney的水平。配合ControlNet等插件，可以实现极为精细的创作控制。</p>
<p>社区生态的繁荣是SD的另一大优势。海量的第三方模型和LoRA让创作者几乎可以实现任何风格和主题的创作需求。</p>

<h2>如何选择？</h2>
<p>如果你追求快速出图和艺术美感，Midjourney是更好的选择；如果你需要精细控制、定制化创作或者本地化部署，Stable Diffusion 4.0更加合适。两者结合使用，效果最佳。</p>`,
    categoryId: "cat-1",
    categoryName: "科技数码",
    categorySlug: "tech",
    author: "数码达人小王",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20tech%20blogger%20avatar%20portrait%20clean%20minimal%20style&width=100&height=100&seq=author-avatar-1&orientation=squarish",
    publishDate: "2026-07-25",
    image: "https://readdy.ai/api/search-image?query=Abstract%20AI%20generated%20art%20displayed%20on%20modern%20monitor%20screen%2C%20warm%20minimal%20desk%20setup%2C%20creative%20workspace%2C%20soft%20ambient%20lighting%2C%20clean%20composition&width=800&height=450&seq=art-tech-2&orientation=landscape",
    views: 22340,
    likes: 3456,
    comments: 789,
    tags: ["AI绘画", "Midjourney", "Stable Diffusion", "科技评测"],
    isHot: false,
    isRecommended: true,
  },
  {
    id: "art-8",
    title: "新手养猫全攻略：从选猫到日常护理的完整指南",
    slug: "cat-care-beginner-guide",
    excerpt: "想养一只猫咪但不知道从哪里开始？这篇指南涵盖选猫、环境准备、日常喂养、健康护理等全部环节，手把手教你成为合格的铲屎官。",
    contentHtml: `<p>猫咪是当下最受欢迎的宠物之一，独立又粘人的性格让无数人沦为了"猫奴"。如果你正准备迎接人生中第一只猫咪，这篇指南将是你最好的入门助手。</p>

<h2>选猫篇：找到你的天命之猫</h2>
<p>选择猫咪时需要考虑品种、年龄和来源。新手建议选择性格温顺的品种，如英短、美短或布偶猫。年龄方面，幼猫虽然可爱但需要更多照顾，成年猫性格稳定更适合新手。</p>
<p>来源建议优先选择正规猫舍或领养替代购买。无论哪种方式，都要仔细确认猫咪的健康状况。</p>

<h2>环境准备：打造猫咪天堂</h2>
<p>猫砂盆、猫抓板、食盆水盆是必备三件套。猫爬架可以满足猫咪攀爬的天性，各种玩具则能保持它的运动量。记得把家中危险物品（电线、小物件、有毒植物等）收好。</p>

<h2>日常喂养与护理</h2>
<p>猫咪是纯肉食动物，选择优质的猫粮至关重要。定期梳毛、剪指甲、清洁耳朵都是必备的日常护理。最重要的是，每年至少带猫咪做一次体检。</p>`,
    categoryId: "cat-2",
    categoryName: "生活娱乐",
    categorySlug: "lifestyle",
    author: "宠物达人喵酱",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20pet%20blogger%20avatar%20portrait%20cute%20warm%20style&width=100&height=100&seq=author-avatar-7&orientation=squarish",
    publishDate: "2026-07-22",
    image: "https://readdy.ai/api/search-image?query=Cute%20orange%20tabby%20cat%20relaxing%20on%20warm%20sofa%20with%20soft%20blanket%2C%20cozy%20home%20interior%2C%20natural%20window%20light%2C%20peaceful%20atmosphere%2C%20gentle%20pet%20photography&width=800&height=450&seq=art-life-2&orientation=landscape",
    views: 38450,
    likes: 6789,
    comments: 1567,
    tags: ["养猫", "宠物", "新手攻略", "猫咪护理"],
    isHot: true,
    isRecommended: false,
  },
  {
    id: "art-9",
    title: "考研英语80分备考经验：从规划到执行的全流程分享",
    slug: "postgraduate-english-80-tips",
    excerpt: "考研英语是很多考生的拦路虎。本文作者英语二85分上岸，将从单词、阅读、写作等模块分享自己的备考方法和时间规划。",
    contentHtml: `<p>考研英语是拉开分数差距的关键科目。我去年英语二考了85分，今天把备考经验整理出来，希望对学弟学妹们有所帮助。</p>

<h2>时间规划：3-12月的完整时间线</h2>
<p>3-6月打基础：这个阶段以背单词和分析长难句为主，每天投入1-2小时。7-9月强化期：开始刷真题（至少近10年的），精读每篇文章，分析错题。10-12月冲刺期：重点训练写作和翻译，保持阅读手感。</p>

<h2>单词记忆：方法和坚持同样重要</h2>
<p>推荐使用艾宾浩斯记忆法配合背单词APP。不要试图一次性记住所有释义，先掌握核心意思即可。每天新学50个复习150个，坚持三个月词汇量就有质的飞跃。</p>

<h2>阅读理解：考研英语的半壁江山</h2>
<p>考研英语"得阅读者得天下"不是空话。做阅读不仅要选对答案，更要理解文章的逻辑结构和出题人的命题思路。建议每篇文章做完后进行全文翻译和分析。</p>`,
    categoryId: "cat-3",
    categoryName: "学习教育",
    categorySlug: "education",
    author: "考研学姐Amy",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20graduate%20student%20avatar%20portrait%20studious%20style&width=100&height=100&seq=author-avatar-8&orientation=squarish",
    publishDate: "2026-07-20",
    image: "https://readdy.ai/api/search-image?query=Study%20desk%20with%20English%20textbooks%20and%20notebooks%2C%20warm%20lamp%20light%2C%20cozy%20academic%20atmosphere%2C%20organized%20workspace%2C%20soft%20focus%2C%20motivational%20study%20scene&width=800&height=450&seq=art-edu-2&orientation=landscape",
    views: 19870,
    likes: 2890,
    comments: 567,
    tags: ["考研", "英语", "备考经验", "学习方法"],
    isHot: false,
    isRecommended: false,
  },
  {
    id: "art-10",
    title: "原神5.0枫丹篇完整剧情解析与隐藏彩蛋汇总",
    slug: "genshin-impact-fontaine-story-analysis",
    excerpt: "原神5.0版本枫丹主线剧情迎来高潮。本文为你深度解析剧情走向，挖掘那些容易被忽略的隐藏细节和彩蛋。",
    contentHtml: `<p>原神5.0版本的主线剧情让无数旅行者又哭又笑。枫丹篇的故事深度和情感张力都达到了新的高度，今天就来做一个全面的剧情解析。</p>

<h2>主线剧情回顾</h2>
<p>枫丹篇围绕"正义"这一主题展开，水神芙宁娜的形象塑造可以说是整个原神中最复杂的角色之一。从表面的高傲到内心的脆弱，编剧层层剥开她的真实面目。</p>

<h2>隐藏剧情线解析</h2>
<p>枫丹城中散布着大量与主线相关的支线任务和世界任务，这些看似独立的剧情其实都在为主线做铺垫。如果你没有认真做这些支线，会错过很多重要的伏笔和细节。</p>

<h2>彩蛋与致敬</h2>
<p>枫丹篇中隐藏了大量对经典文学和电影作品的致敬。从雨果的《悲惨世界》到歌剧魅影，这些文化彩蛋让整个枫丹篇更加丰富立体。</p>`,
    categoryId: "cat-4",
    categoryName: "游戏动漫",
    categorySlug: "gaming",
    author: "游戏观察员",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20game%20reviewer%20avatar%20portrait%20casual%20style&width=100&height=100&seq=author-avatar-4&orientation=squarish",
    publishDate: "2026-07-18",
    image: "https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20city%20with%20water%20theme%2C%20elegant%20architecture%2C%20soft%20blue%20tones%2C%20atmospheric%20game%20environment%20art%2C%20beautiful%20landscape&width=800&height=450&seq=art-game-2&orientation=landscape",
    views: 45230,
    likes: 7234,
    comments: 1890,
    tags: ["原神", "游戏剧情", "枫丹", "彩蛋"],
    isHot: true,
    isRecommended: true,
  },
  {
    id: "art-11",
    title: "独立音乐人崛起：2026年你不能错过的十张华语独立专辑",
    slug: "indie-chinese-music-2026",
    excerpt: "华语独立音乐正在经历一场前所未有的繁荣。从民谣到电子，从摇滚到实验，这些独立音乐人正在重新定义华语音乐的可能性。",
    contentHtml: `<p>如果说十年前华语独立音乐还处于地下状态，那么2026年的今天，独立音乐已经成为了主流文化的重要组成部分。</p>

<h2>独立音乐的黄金时代</h2>
<p>流媒体平台的普及让独立音乐人有了直接触达听众的渠道。不再依赖传统唱片公司的发行体系，越来越多的音乐人选择独立制作和发行自己的作品。这种去中心化的趋势，让华语音乐的多样性达到了前所未有的高度。</p>

<h2>年度十佳推荐</h2>
<p>从台北的卧室制作人到成都的地下乐队，从上海的电子音乐人到北京的民谣歌手——这十张专辑代表了2026年华语独立音乐的最高水准。</p>
<p>每一张专辑都有其独特的音乐语言和表达方式，但它们共同的特点是：真诚、有态度、不迎合市场。</p>`,
    categoryId: "cat-5",
    categoryName: "影视音乐",
    categorySlug: "entertainment",
    author: "乐评人阿飞",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20music%20critic%20avatar%20portrait%20artistic%20style&width=100&height=100&seq=author-avatar-9&orientation=squarish",
    publishDate: "2026-07-15",
    image: "https://readdy.ai/api/search-image?query=Vintage%20vinyl%20record%20player%20on%20wooden%20table%2C%20warm%20ambient%20lighting%2C%20music%20listening%20room%2C%20cozy%20atmosphere%2C%20retro%20aesthetic%20with%20soft%20shadows&width=800&height=450&seq=art-music-1&orientation=landscape",
    views: 15230,
    likes: 2134,
    comments: 445,
    tags: ["独立音乐", "华语音乐", "专辑推荐", "音乐评论"],
    isHot: false,
    isRecommended: false,
  },
  {
    id: "art-12",
    title: "冥想入门：每天十分钟，改变你的人生",
    slug: "meditation-beginner-guide",
    excerpt: "科学研究证实，每天坚持冥想可以显著改善注意力、减轻压力、提升幸福感。本文为零基础读者提供一套简单实用的冥想入门方法。",
    contentHtml: `<p>在快节奏的现代生活中，我们的注意力被无数信息碎片切割，内心难得片刻安宁。冥想，作为一种古老的修心方法，已经被现代科学证实其诸多益处。</p>

<h2>为什么要冥想？科学怎么说</h2>
<p>哈佛大学的研究表明，坚持冥想8周就能在大脑结构上产生可测量的变化。负责学习和记忆的海马体体积增加，负责焦虑和压力的杏仁核体积缩小。冥想还能降低皮质醇水平，改善睡眠质量。</p>

<h2>初学者指南：五分钟入门冥想</h2>
<p>找一个安静舒适的地方坐下，背挺直但不僵硬。闭上眼睛，把注意力放在自然的呼吸上。不需要刻意改变呼吸节奏，只是观察空气进入鼻腔、充满胸腔、然后缓缓呼出的过程。</p>
<p>思绪飘走是完全正常的——不要自责，温柔地把注意力带回呼吸即可。这个"觉察走神并拉回来"的过程，就是冥想的核心练习。</p>

<h2>持续练习的建议</h2>
<p>建议从每天5分钟开始，逐渐增加到10-20分钟。固定时间和地点有助于养成习惯。使用冥想APP作为辅助工具也是不错的选择。</p>`,
    categoryId: "cat-6",
    categoryName: "健康养生",
    categorySlug: "health",
    author: "心理咨询师小周",
    authorAvatar: "https://readdy.ai/api/search-image?query=Chinese%20psychologist%20avatar%20portrait%20calm%20professional%20style&width=100&height=100&seq=author-avatar-10&orientation=squarish",
    publishDate: "2026-07-12",
    image: "https://readdy.ai/api/search-image?query=Peaceful%20meditation%20space%20with%20yoga%20mat%20and%20candles%2C%20warm%20natural%20light%20through%20curtains%2C%20minimal%20and%20serene%20interior%2C%20calm%20atmosphere%2C%20soft%20focus&width=800&height=450&seq=art-health-2&orientation=landscape",
    views: 26780,
    likes: 3987,
    comments: 876,
    tags: ["冥想", "心理健康", "压力管理", "自我提升"],
    isHot: false,
    isRecommended: false,
  },
];